module.exports = __webpack_public_path__ + "img/ico_review_more.9831d835.svg";